import { jsonPost, jsonGet, jsonPut, jsonDelete } from "../api.js";

export const getMcpServers = async () => jsonGet("mcp-servers");
export const getMcpServer = async (id) => jsonGet(`mcp-servers/${id}`);
export const createMcpServer = async (data) => jsonPost("mcp-servers", data);
export const updateMcpServer = async (id, data) =>
  jsonPut(`mcp-servers/${id}`, data);
export const deleteMcpServer = async (id) => jsonDelete(`mcp-servers/${id}`);
export const discoverMcpTools = async (id) =>
  jsonPost(`mcp-servers/${id}/discover`);
export const importMcpTools = async (id, toolNames) =>
  jsonPost(`mcp-servers/${id}/import`, { toolNames });
